module.exports = __webpack_public_path__ + "static/media/injuredMinor.c6d8f2f8.mp3";